export default {};

export function basePath(currentPage: string): string {
    if (currentPage === '') return '';

    return currentPage
        .split('/')
        .flatMap((pathSegment) => (pathSegment !== '' ? '..' : []))
        .join('/');
}
